import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface HouseholderPageProps extends BasePageProps {}

type HouseholderState = {
    familiari: number | undefined
    animali: boolean | undefined
    animali_pericolosi: boolean | undefined
    tipo_animali: string | undefined
    altri_animali: string | undefined

    familiariError: string | undefined
    animaliError: string | undefined
    animali_pericolosiError: string | undefined
    tipo_animaliError: string | undefined
    altri_animaliError: string | undefined

    tipi: any
}

export type HouseholderPageState = HouseholderState & BasePageState

export const householderPageInitialState : HouseholderPageState = {
    ...basePageInitialState,
    ...{
        familiari: undefined,
        animali: undefined,
        animali_pericolosi: undefined,
        tipo_animali: undefined,
        altri_animali: undefined,

        familiariError: undefined,
        animaliError: undefined,
        animali_pericolosiError: undefined,
        tipo_animaliError: undefined,
        altri_animaliError: undefined,

        tipi: undefined,
    }
}

export const householderUpdate = createAction<HouseholderPageState>('householder/update')

export const householderReducer = createReducer ( 
    householderPageInitialState,
    (builder) => {
        builder.addCase(householderUpdate, (state, action) => {
            return action.payload as HouseholderPageState
        })
    }
)

export type HouseholderRootState = ReturnType<typeof store.getState>
export type HouseholderDispatch = typeof store.dispatch